import jQuery from "jquery";
import * as bootstrap from "bootstrap";

// Django templates and the theme share the same maintained local vendor instances.
Object.assign(window, {jQuery, $: jQuery, bootstrap});
